import {ChangeDetectionStrategy, Component} from '@angular/core';
import {concat, Observable, of} from 'rxjs';
import {DashboardCrmService} from '@service/dashboard-crm/dashboard-crm.service';
import {CrmDataCard} from '@interface/crm/crm-data-card';
import {CrmSection} from '@enum/crm-section';
import {AuthService} from '@service/auth/auth.service';
import {CustomIconType} from '@enum/icons/icon-type';
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

type CardItem = {
  icon: CustomIconType;
  link: string;
  observable: Observable<CrmDataCard>;
  title: string;
  comingSoon: boolean;
  section: CrmSection
};

@Component({
    selector: 'app-dashboard-crm',
    templateUrl: './dashboard-crm.component.html',
    styleUrls: ['./dashboard-crm.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DashboardCrmComponent {
  cards: CardItem[];
  reportData;

  constructor(private dashboardService: DashboardCrmService, private authService: AuthService, private sanitizer: DomSanitizer) {
    this.dashboardService.title = 'CRM - Dashboard';
    this.reportData = this.dashboardService.report(this.canSeeReport());
    const allCards: CardItem[] = [
      {
        title: 'LEAD',
        comingSoon: false,
        link: '/crm/customers/lead',
        icon: 'icon-ipe-add-user',
        observable: this.dashboardService.getLeads(),
        section: CrmSection.Lead
      },
      {
        title: 'VERIFIED_CONTACTS',
        comingSoon: false,
        link: '/crm/customers/verified-contacts',
        icon: 'icon-ipe-user-validation',
        observable: this.dashboardService.verifiedContacts(),
        section: CrmSection.VerifiedContact
      },
      {
        title: 'CUSTOMER_LIST',
        comingSoon: false,
        link: '/crm/customers/contact-list',
        icon: 'icon-ipe-customers',
        observable: this.dashboardService.customerList(),
        section: CrmSection.CustomerList
      },
      {
        title: 'SALES_TASKS',
        comingSoon: false,
        link: '/crm/tasks',
        icon: 'icon-ipe-sales-tasks',
        observable: this.dashboardService.salesTask(),
        section: CrmSection.SalesTasks
      },
      // {
      //   title: 'ORDERS',
      //   comingSoon: true,
      //   link: '',
      //   icon: 'icon-ipe-orders-06',
      //   observable: this.dashboardService.orders(),
      //   section: CrmSection.Orders
      // },
      {
        title: 'CLAIMS',
        comingSoon: false,
        link: '/crm/claims',
        icon: 'icon-ipe-communications-chat',
        observable: this.dashboardService.claims(),
        section: CrmSection.Claims
      },
    ];
    this.cards = allCards.filter((icon) => authService.currentUserPermission.crmSectionsVisible.includes(icon.section))
      .map((data) => ({
      ...data,
      observable: this.concatAfterEmpty(data.observable)
    }));
  }

  trackByIndex(index: number): number {
    return index;
  }

  concatAfterEmpty(observable: Observable<CrmDataCard>): Observable<CrmDataCard> {
    return concat(of({keys: [], values: []}), observable);
  }

  canSeeReport(): boolean {
    return this.authService.currentUserPermission.crmSectionsVisible.includes(CrmSection.Report);
  }

  lookerUrl(): string {
    return this.authService.lookerUrl || '';
  }

  lookerSafeUrl(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.lookerUrl());
  }
}
